export const MIN_DIMENSION = 200; // in pixels

export const imageDimensionsTooSmall = (objectUrl) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function() {
      return resolve(this.width < MIN_DIMENSION || this.height < MIN_DIMENSION);
    }

    img.src = objectUrl;
  });
};

